import { axiosRef } from '../../../api';
import { formatDateWithDashes } from '../../../utils/helper';
import { lmsLoadByTypeReportPayload } from '../interfaces';

export default async function getLmsAircraftLoadByTypeReport(
  payload: lmsLoadByTypeReportPayload,
  isAdmin: boolean,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `/business_central/lms/report/aircraft_load_by_type?`;

  if (payload && payload.startDate && payload.endDate) {
    const start = formatDateWithDashes(payload.startDate);
    const end = formatDateWithDashes(payload.endDate);
    url += `start_date=${start}&end_date=${end}&`;
  }

  if (payload && payload.fileType) {
    url = url + `&report_type=${payload.fileType}`;
  }

  if (payload && payload?.originCode) {
    url = url + `&origin_code=${payload.originCode}`;
  }

  if (payload && payload?.destinationCode) {
    url = url + `&destination_code=${payload.destinationCode}`;
  }

  if (payload && payload?.status) {
    url = url + `&status=${payload.status}`;
  }

  if (isAdmin && payload && payload?.jobNo) {
    url = url + `&job_no=${payload.jobNo}`;
  }

  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const report = response.data.content;
      return {
        report,
      };
    }
    setLoading(false);
    return {
      report: null,
    };
  } catch (error) {
    setLoading(false);
    return {
      report: null,
    };
  }
}
